/* eslint-disable @next/next/no-img-element */
// HERO "Aurora" (modelo_busca = 13): hero EMOLDURADO do modelo "Aurora" — a mídia do
// tenant (vídeo > banner > capa do vídeo > degradê) vive num bloco com margem lateral e
// cantos de 28px, com véu em gradiente (escuro no alto, para o topo 10 transparente ler;
// mais escuro embaixo, para o texto; o véu é LEVE: o vídeo aparece). Conteúdo centrado, no pé:
//  - frase da home do tenant (site.frase_busca, a mesma dos heros 7/11) em tipografia
//    grande e forte + subtítulo (site.frase_busca_2) + tags de busca (CardsBusca);
//  - a BUSCA é uma BARRA BRANCA de cantos 24px que FLUTUA sobre a borda inferior da moldura
//    (metade sobre o vídeo, metade sobre o fundo da página), centrada na largura do conteúdo
//    — a pílula branca do Airbnb e os heros da Compass/Sotheby's: abas de transação em
//    controle SEGMENTADO claro (ativa = cor2 sólida), campos Cidade · Tipo · Quartos em linha
//    com divisórias finas, ícone e rótulo pequeno acima do valor, botão "Buscar imóveis" sólido
//    na cor2 com lupa e o botão "Busca avançada", que abre o painel de filtros avançados
//    (BuscaAvancadaAurora: bairros, preço, área, suítes, banheiros, vagas, categoria,
//    características, entrega, condomínio, código — URL no contrato da listagem); no celular os
//    campos empilham no mesmo cartão.
// O bloco não depende do topo 10: com qualquer topo ele é só a primeira seção da home.
// A busca (estado/URL/tracking Meta/filial ativa) vem inteira do hook compartilhado
// useHeroSearch; este componente só desenha os controles. Cores por papel (var(--corN,
// #fallback)); onde o fundo é cor do tenant, o texto é CALCULADO (isColorLight +
// ensureReadableTextColor). Default export = ErrorBoundary com fallback (padrão WelcomeAutoral).
import { useRouter } from 'next/router';
import React, { useCallback, useMemo, useState } from 'react';
import type { CSSProperties } from 'react';
import { ensureReadableTextColor, isColorLight } from '../../../utils/FunctionsGlobals';
import { getHeroVideoPoster, getTenantVideoCover, useHeroVideoReady } from '../../../utils/heroVideo';
import { genMetaEventId, trackMetaEvent } from '../../../utils/metaPixel';
import HeroVideoCover from '../../utils/HeroVideoCover';
import type { HeroSectionProps } from '../../registry/types';
import { useHeroSearch } from '../../shared/hero-search/useHeroSearch';
import CampoSelecaoMulti from '../../shared/hero-search/CampoSelecaoMulti';
import CampoQuantidadeMulti from '../../shared/hero-search/CampoQuantidadeMulti';
import CardsBusca from '../../shared/cards-busca/CardsBusca';
import DrawerComponent from '../../drawer/DrawerComponent';
import { hexParaRgba } from '../aurora/aurora';
import BuscaAvancadaAurora from './BuscaAvancadaAurora';
import styles from './WelcomeAurora.module.css';
import { usePreviaBuilder } from '../../../lib/previaBuilder';

const stripHtml = (value: unknown): string =>
    String(value ?? '')
        .replace(/<[^>]+>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

const IconePino = () => (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M12 21s-6-5.3-6-10.5a6 6 0 0 1 12 0C18 15.7 12 21 12 21z" />
        <circle cx="12" cy="10.5" r="2.3" />
    </svg>
);
const IconeCasa = () => (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M3 11.5 12 4l9 7.5" />
        <path d="M5.5 10v10h13V10" />
        <path d="M10 20v-6h4v6" />
    </svg>
);
const IconeCama = () => (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M3 18v-7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v7" />
        <path d="M3 15h18M5 9V6.5A1.5 1.5 0 0 1 6.5 5h4A1.5 1.5 0 0 1 12 6.5V9" />
    </svg>
);
const IconeLupa = () => (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true">
        <circle cx="11" cy="11" r="7" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
);

const WelcomeAuroraInner: React.FC<HeroSectionProps> = ({
    allCities,
    allTypes,
    allTransacao,
    site,
    urlBanner,
    origin,
    codsite,
    codsite2,
    allCompany,
    setActiveDrawer,
    activeDrawer,
    favorito,
    isMobile1,
    props,
    allCards,
}) => {
    const { videoParado } = usePreviaBuilder(); // prévia dos cards do CRM: vídeo parado na capa
    const {
        transacoes,
        transacao,
        setTransacao,
        cidade,
        setCidade,
        tipo,
        setTipo,
        dormitorios,
        setDormitorios,
        loading,
        onSubmit,
        finalize,
    } = useHeroSearch({ site, allCities, allTypes, allTransacao, codsite2, origin });

    // ---- cores: papéis da paleta do catálogo; o hex do CSS é a rede de segurança ----
    const acao = site?.cor2 || '#2563eb';
    const corAcaoTexto = ensureReadableTextColor(isColorLight(acao) ? site?.cor11 : site?.cor13, acao) || '#ffffff';
    // A barra é SEMPRE branca (Daniel, 14/10): texto = cor11 do tenant legível sobre o branco.
    const corPainelTexto = ensureReadableTextColor(site?.cor11, '#ffffff') || '#1c2230';
    // "Busca avançada": a cor2 legível sobre o branco (ou o próprio texto da barra).
    const corLinkPainel = ensureReadableTextColor(site?.cor2, '#ffffff', 3.0, corPainelTexto, corPainelTexto) || corPainelTexto;

    // ---- mídia de fundo: vídeo do tenant (fora do celular) > banner "topo" > capa > degradê ----
    const bannerSrc = urlBanner && urlBanner !== 'undefined' ? String(urlBanner).replaceAll('"', '') : '';
    const videoSrc = site?.url_video && !isMobile1 ? String(site.url_video).replaceAll('"', '') : '';
    const heroPoster = getHeroVideoPoster(site?.url_video);
    const heroVideoReady = useHeroVideoReady();
    // No celular o vídeo fica desligado, mas a CAPA dele entra no lugar do degradê (#1271).
    const capaVideo = site?.url_video_poster || heroPoster || getTenantVideoCover(site?.url_video);

    const titulo = useMemo(() => (site?.frase_busca ? stripHtml(site.frase_busca) : 'Encontre o imóvel perfeito para você'), [site?.frase_busca]);
    const subtitulo = useMemo(() => (site?.frase_busca_2 ? stripHtml(site.frase_busca_2) : ''), [site?.frase_busca_2]);

    // Tokens da barra: texto calculado + divisórias/trilha derivadas dele (sempre sobre o branco).
    const varsPainel = {
        '--aurora-campo-texto': corPainelTexto,
        '--aurora-campo-borda': hexParaRgba(corPainelTexto, 0.12),
        '--aurora-campo-foco': hexParaRgba(corPainelTexto, 0.55),
        '--aurora-campo-trilha': hexParaRgba(corPainelTexto, 0.06),
        '--aurora-campo-link': corLinkPainel,
        color: corPainelTexto,
    } as CSSProperties;

    // A CAIXA inteira do campo abre a lista (alvo de toque de 60px, não só o input): foca o
    // input e dispara o click dele (que só ABRE o painel — não alterna), fora do próprio input.
    const abrirCampo = (e: React.MouseEvent<HTMLDivElement>) => {
        const input = e.currentTarget.querySelector('input');
        if (input && e.target !== input) {
            input.focus();
            input.click();
        }
    };

    // ---- busca avançada: painel de filtros (BuscaAvancadaAurora) aberto pelo botão da barra ----
    const router = useRouter();
    const [avancadaAberta, setAvancadaAberta] = useState(false);
    const [qtdAvancada, setQtdAvancada] = useState(0);
    const fecharAvancada = useCallback(() => setAvancadaAberta(false), []);
    const buscarAvancada = (url: string) => {
        // evento Search com o mesmo eventId que a listagem usa na dedup do CAPI (como o hook)
        const eventId = genMetaEventId();
        try {
            sessionStorage.setItem('meta:searchEventId', JSON.stringify({ id: eventId, at: Date.now() }));
        } catch {
            /* sessionStorage indisponível */
        }
        trackMetaEvent(site, 'Search', { search_string: 'busca avançada', transaction_type: transacao }, { eventId });
        setAvancadaAberta(false);
        router.push(url).catch(() => undefined);
    };

    return (
        <section className={styles.aurora} data-builder-section="busca">
            <DrawerComponent
                site={site}
                activeDrawer={activeDrawer}
                setActiveDrawer={setActiveDrawer}
                favorito={favorito || []}
                menus={props?.menus}
            />

            <div className={styles.palco}>
                <div className={styles.moldura}>
                    {/* ---------- mídia ---------- */}
                    <div className={styles.media} aria-hidden="true">
                        {videoSrc ? (
                            <video
                                className={styles.mediaEl}
                                autoPlay={!videoParado}
                                muted
                                loop
                                playsInline
                                preload="none"
                                poster={heroPoster}
                                src={heroPoster ? (heroVideoReady ? videoSrc : undefined) : videoSrc}
                            >
                                <track kind="captions" label="Legenda" src="legenda.vtt" />
                            </video>
                        ) : bannerSrc ? (
                            <img className={styles.mediaEl} src={bannerSrc} alt="" decoding="async" />
                        ) : (
                            <HeroVideoCover src={capaVideo} className={styles.mediaEl} fallbackClassName={styles.mediaFallback} />
                        )}
                        <div className={styles.veu} />
                    </div>

                    {/* ---------- conteúdo (esquerda/baixo) ---------- */}
                    <div className={styles.conteudo}>
                        <h1 className={styles.titulo}>{titulo}</h1>
                        {subtitulo ? <p className={styles.subtitulo}>{subtitulo}</p> : null}
                        <CardsBusca cards={allCards} site={site} variante="escuro" className={styles.cards} />
                    </div>
                </div>

                {/* ---------- painel de busca: flutua sobre a borda inferior da moldura ----------
                    id="myLink": âncora do botão "BUSCA AVANÇADA" do topo (topo2). */}
                <form id="myLink" className={styles.painel} style={varsPainel} onSubmit={onSubmit}>
                    {transacoes.length > 1 ? (
                        <div className={styles.abas} role="tablist" aria-label="Tipo de negócio">
                            {transacoes.map((t) => {
                                const value = String(t.value).toLowerCase();
                                const ativa = value === transacao;
                                return (
                                    <button
                                        key={value}
                                        type="button"
                                        role="tab"
                                        aria-selected={ativa}
                                        className={`${styles.aba} ${ativa ? styles.abaAtiva : ''}`}
                                        style={ativa ? { background: acao, color: corAcaoTexto } : undefined}
                                        onClick={() => setTransacao(value)}
                                    >
                                        {t.label}
                                    </button>
                                );
                            })}
                        </div>
                    ) : (
                        <span className={styles.rotuloPainel}>Encontre seu imóvel</span>
                    )}

                    <button
                        type="button"
                        className={styles.avancada}
                        aria-haspopup="dialog"
                        aria-expanded={avancadaAberta}
                        onClick={() => setAvancadaAberta(true)}
                    >
                        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
                            <line x1="4" y1="7" x2="20" y2="7" />
                            <line x1="4" y1="12" x2="20" y2="12" />
                            <line x1="4" y1="17" x2="20" y2="17" />
                            <circle cx="9" cy="7" r="2" fill="#fff" />
                            <circle cx="15" cy="12" r="2" fill="#fff" />
                            <circle cx="10" cy="17" r="2" fill="#fff" />
                        </svg>
                        Busca avançada
                        {qtdAvancada ? (
                            <span className={styles.avancadaQtd} style={{ background: acao, color: corAcaoTexto }} aria-label={`${qtdAvancada} filtros ativos`}>
                                {qtdAvancada}
                            </span>
                        ) : null}
                    </button>

                    <div className={styles.campos}>
                        {/* div, não label: o painel de sugestões mora dentro do campo e um
                            <label> em volta de um listbox rotularia a lista inteira. */}
                        <div className={styles.caixa} onClick={abrirCampo}>
                            <span className={styles.icone}>
                                <IconePino />
                            </span>
                            <span className={styles.caixaTexto}>
                                <span className={styles.rotulo}>Onde</span>
                                <CampoSelecaoMulti
                                    opcoes={allCities || []}
                                    valor={cidade}
                                    onChange={setCidade}
                                    rotuloVazio="Todas as cidades"
                                    plural="cidades"
                                    ariaLabel="Cidade"
                                    className={styles.campo}
                                />
                            </span>
                        </div>
                        <div className={styles.caixa} onClick={abrirCampo}>
                            <span className={styles.icone}>
                                <IconeCasa />
                            </span>
                            <span className={styles.caixaTexto}>
                                <span className={styles.rotulo}>Tipo</span>
                                <CampoSelecaoMulti
                                    opcoes={allTypes || []}
                                    valor={tipo}
                                    onChange={setTipo}
                                    rotuloVazio="Todos os tipos"
                                    plural="tipos"
                                    ariaLabel="Tipo de imóvel"
                                    className={styles.campo}
                                />
                            </span>
                        </div>
                        <div className={`${styles.caixa} ${styles.caixaCurta}`} onClick={abrirCampo}>
                            <span className={styles.icone}>
                                <IconeCama />
                            </span>
                            <span className={styles.caixaTexto}>
                                <span className={styles.rotulo}>Quartos</span>
                                {/* vários números (2 e 3 quartos) — Daniel 20/10, igual à lateral de /imoveis */}
                                <CampoQuantidadeMulti
                                    valor={dormitorios}
                                    onChange={setDormitorios}
                                    rotuloVazio="Tanto faz"
                                    singular="quarto"
                                    plural="quartos"
                                    ariaLabel="Quartos"
                                    className={styles.campo}
                                />
                            </span>
                        </div>

                        <button
                            type="submit"
                            className={styles.buscar}
                            style={{ background: acao, color: corAcaoTexto }}
                            disabled={loading}
                            aria-label="Buscar imóveis"
                            title="Buscar imóveis"
                        >
                            <IconeLupa />
                            <span className={styles.buscarLabel}>{loading ? 'Buscando...' : 'Buscar imóveis'}</span>
                        </button>
                    </div>
                </form>
            </div>

            <BuscaAvancadaAurora
                aberto={avancadaAberta}
                onFechar={fecharAvancada}
                site={site}
                origin={origin}
                codsite={codsite || codsite2}
                allCities={allCities || []}
                allTypes={allTypes || []}
                allCompany={allCompany}
                basico={{ transacao, cidade, tipo, dormitorios }}
                setDormitorios={setDormitorios}
                finalize={finalize}
                onBuscar={buscarAvancada}
                onContagem={setQtdAvancada}
                corAcao={acao}
                corAcaoTexto={corAcaoTexto}
                corTexto={corPainelTexto}
            />
        </section>
    );
};

class WelcomeAurora extends React.Component<HeroSectionProps, { hasError: boolean }> {
    constructor(props: HeroSectionProps) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch() {
        // silencioso: degrada pro fallback sem quebrar a home.
    }
    render() {
        const { fallback, site } = this.props;
        if (this.state.hasError || !site) return fallback ?? null;
        return <WelcomeAuroraInner {...this.props} />;
    }
}

export default WelcomeAurora;
